<template>
  <ThankYouPage />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ThankYouPage from 'chimera/all/themes/blueflow/page/ThankYou/ThankYouPage'

export default {
  components: {
    ThankYouPage,
  },

  extends: AbstractPage,

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Aanvraag afgerond',
      headDescription:
        'Vergelijk vakkundige bedrijven op Accountantvergelijker.nl. Snel, betrouwbaar en alleen offertes uit jouw regio. Bespaar tot wel 40%.',
      path: '/offertes-aanvragen/aanvraag-afgerond',
    }
  },
}
</script>
